import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Box, Grid, Typography, Tooltip as Tp } from "@mui/material";
import { getDeletedTasks, getTerminatedTasks, getTerminatedTasksList } from "api/services/clients/clients";
// import { getPins } from "api/services/clients/client-pin";
import useQueryParams from "hooks/useQueryParams";
import { useState } from "react";
import { useQuery } from "react-query";
import { ResType } from "types";
// import { StyledClientFilterItem, StyledMoreHorButton } from "../styles";
// import ClientFilterItem from "./ClientFilterItem";
// import ClientPopover from "./ClientPopover";
import { getTaskAnalytics, getTaskBoardAnalytics } from "api/services/organization";
import { completed, deleted, inprog, onhold, terminate, todo, underrev } from "assets";
// import { imageStyles, taskItemStyle, typographyBody1, typographyH6 } from "./commonStyles";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import "pages/GridStyling.css";

const taskItemStyle = {
    backgroundColor: "#ffffff",
    padding: "10px 15px",
    borderRadius: "8px",
    height: "60px",
    width: "220px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    margin: "10px 18px 25px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
};

const typographyH6 = {
    display: "flex",
    alignItems: "center",
    fontWeight: 800,
    fontSize: "16px",
    lineHeight: "15.57px",
};

const typographyBody1 = {
    fontWeight: 800,
    fontSize: "20px",
    lineHeight: "33.89px",
    marginLeft: "8px",
};

const imageStyles = {
    width: 17,
    height: 17,
    marginRight: 6,
};
export { taskItemStyle, typographyH6, typographyBody1, imageStyles };

function TaskListView() {
    const { queryParams, setQueryParams } = useQueryParams();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [TerminatedTaskCount, setTerminatedTaskCount] = useState("");

    const { data, isLoading }: ResType = useQuery(
        [
            "tasks-by-status", { clientId: localStorage.getItem("clientId") } 
        ],
        getTaskBoardAnalytics
    );

    return (
        <>
            <Box className="taskListViewContainer taskListViewContainerMobile">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={2.4} >
                        <Box style={taskItemStyle}>
                            <Typography variant="h6" style={typographyH6}>
                                <img src={todo} alt="Todo icon" style={{ width: 17, height: 17, marginRight: 5 }} />
                                Todo
                            </Typography>
                            <Typography variant="body1" style={typographyBody1}>{data?.data?.tasksByStatus?.["todo"] || 0}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={2.4} >
                        <Box style={taskItemStyle}>
                            <Typography variant="h6" style={typographyH6}>
                                <img src={inprog} alt="Todo icon" style={imageStyles} />In Progress</Typography>
                            <Typography variant="body1" style={typographyBody1}>{data?.data?.tasksByStatus?.["in_progress"] || 0}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={2.4} >
                        <Box style={taskItemStyle}>
                            <Typography variant="h6" style={typographyH6} >
                                <img src={onhold} alt="Todo icon" style={imageStyles} />On Hold</Typography>
                            <Typography variant="body1" style={typographyBody1}>{data?.data?.tasksByStatus?.["on_hold"] || 0}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={2.4} >
                        <Box style={taskItemStyle}>
                            <Typography variant="h6" style={{ ...typographyH6, whiteSpace: 'nowrap', fontSize: '15px' }}>
                                <img src={underrev} alt="Todo icon" style={imageStyles} />Under Review</Typography>
                            <Typography variant="body1" style={typographyBody1}>{data?.data?.tasksByStatus?.["under_review"] || 0}</Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={2.4}>
                        <Box style={taskItemStyle}>
                            <Typography variant="h6" style={typographyH6}>
                                <img src={completed} alt="Todo icon" style={imageStyles} />
                                Completed
                                <Tp title={<span>Once a task is marked as completed, it is automatically archived and hidden from the Task Board after a predetermined timeframe (1 day, 15 days, or 1 week) as configured by the Admin.</span>}
                                    sx={{ cursor: 'pointer', marginLeft: '7px' }}>
                                    <HelpOutlineIcon fontSize="small" />
                                </Tp>
                            </Typography>

                            <Typography variant="body1" style={typographyBody1}>{data?.data?.tasksByStatus?.["completed"] || 0}</Typography>
                        </Box>
                    </Grid>
                    {/* <Grid item xs={12} sm={2} >
                        <Box style={taskItemStyle} sx={{ mr: 0 }}>
                            <Typography variant="h6" style={typographyH6}>
                                <img src={terminate} alt="Todo icon" style={imageStyles} />
                                Terminated</Typography>
                            <Typography variant="body1" style={typographyBody1}>{data?.data?.tasksByStatus?.["terminated"]}</Typography>
                        </Box>
                    </Grid> */}

                    {/* <Tp title={<span>Exclude all Sub Tasks and Main Tasks that are Terminated, Deleted & Completed more than 15 days ago.</span>}
            sx={{ cursor: 'pointer', }}>
           
          </Tp> */}


                    {/* <Grid item xs={12} sm={2} >
                        <Box style={taskItemStyle}>
                            <Typography variant="h6" style={typographyH6}>
                                <img src={deleted} alt="Todo icon" style={imageStyles} />
                                Deleted</Typography>
                            <Typography variant="body1" style={typographyBody1}>{data?.data?.tasksByStatus?.["deleted"] || 0}</Typography>
                        </Box>
                    </Grid> */}

                </Grid>
            </Box>

        </>
    );
}

export default TaskListView;
